<template>
  <v-container grid-list-xs>
    <div class="serviceTitle">{{$t('service.serviceTitle')}}</div>
    <ol>
      <li v-for="(item,i) in items" :key="i" style="margin-top:20px">
        <div class="listTitle">{{$t(item.title)}}</div>
        <div class="listSubTitle">{{$t(item.subtitle)}}</div>
        <ol style="margin:20px 0 0 30px;">
          <li class="listDesc" v-for="(desc,index) in item.list" :key="index">
            <span>{{$t(desc["text"])}}</span>
           <ul class="listDesc" v-for="(sublist,index) in desc['sublist']" :key="index">
            <span>- {{$t(sublist)}}</span>
            </ul>
          </li>
        </ol>
      </li>
    </ol>
  </v-container>
</template>
<script>
  export default {
    name: "service",
    data() {
      return {
        items: [
          {
            title: 'service.listTitle1',
            list: [
              {text: 'service.listDesc1,1'},
              {text: 'service.listDesc1,2'},
            ]
          },
          {
            title: 'service.listTitle2',
            list: [
              {text:'service.listDesc2,1'},
              {text: 'service.listDesc2,2'},
            ]
          },
          {
            title: 'service.listTitle3',
            list: [
              {text: 'service.listDesc3,1'},
              {text: 'service.listDesc3,2'},
              {text: 'service.listDesc3,3'},
              {text: 'service.listDesc3,4'},
              {text: 'service.listDesc3,5'},
              {text: 'service.listDesc3,6'},
              {text: 'service.listDesc3,7'},
              {text: 'service.listDesc3,8'},
              {text: 'service.listDesc3,9'},
            ]
          },
          {
            title: 'service.listTitle4',
            list: [
              {text: 'service.listDesc4,1'},
              {text: 'service.listDesc4,2'},
              {text: 'service.listDesc4,3'},
              {text: 'service.listDesc4,4'},
              {text: 'service.listDesc4,5'},
              {text: 'service.listDesc4,6'},
            ]
          },
          {
            title: 'service.listTitle5',
            subtitle: 'service.ListTitle5Sub',
            list: [
              {text: 'service.listDesc5,1', 
               sublist: [
                'service.listDesc5,1,1',
               ]},
              {text: 'service.listDesc5,2', 
               sublist: [
                'service.listDesc5,2,1',
                'service.listDesc5,2,2',
                'service.listDesc5,2,3',
               ]},
              {text: 'service.listDesc5,3', 
               sublist: [
                'service.listDesc5,3,1',
                'service.listDesc5,3,2',
               ]},
              {text: 'service.listDesc5,4'},
              {text: 'service.listDesc5,5'},
            ],
          },
          {
            title: 'service.listTitle6',
            list: [
              {text: 'service.listDesc6,1',},
              {text: 'service.listDesc6,2',},
              {text: 'service.listDesc6,3',},
              {text: 'service.listDesc6,5',},
              {text: 'service.listDesc6,6',},
              {text: 'service.listDesc6,7',},
            ]
          },
        ]
      };
    }
  };
</script>
<style scoped>
  .serviceTitle {
    color: #2c3e50;
    font-weight: 500;
    line-height: 1.5;
    font-size: 22px;
    margin-top: 20px;
  }

  .listTitle {
    color: #2c3e50;
    font-weight: 500;
    line-height: 1.5;
    font-size: 18px;
    text-align: left;
  }
  .listSubTitle{
    color: #2c3e50;
    line-height: 1.5;
    font-size: 16px;
    text-align: left;
    margin-top: 10px;
  }

  .listDesc {
    text-align: justify;
    line-height: 1.5;
    font-size: 16px;
    color: #2c3e50;
    margin-top: 10px;
  }
</style>